export const NAME_TIME_MODAL = 'tiempo de modal'
export const NAME_CONFIGURATION_RETURN = 'Configuración devoluciones'
